var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.616,
    height: 20.5,
    viewBox: "0 0 20.616 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings",
    transform: "translate(0.308 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12928",
    "data-name": "Path 12928",
    d: "M21.708,13.6v-1.1l1.413-1.2a1.406,1.406,0,0,0,.28-1.827L21.664,6.613A1.479,1.479,0,0,0,20.391,5.9a1.508,1.508,0,0,0-.471.072l-1.788.587a8.411,8.411,0,0,0-.964-.537l-.375-1.805A1.463,1.463,0,0,0,15.322,3.06H11.879a1.463,1.463,0,0,0-1.471,1.153l-.375,1.805a8.51,8.51,0,0,0-.971.537L7.31,5.939A1.51,1.51,0,0,0,6.839,5.9a1.479,1.479,0,0,0-1.273.716L3.83,9.478a1.406,1.406,0,0,0,.3,1.8l1.39,1.239v1.1l-1.39,1.2a1.406,1.406,0,0,0-.3,1.827l1.736,2.865a1.479,1.479,0,0,0,1.273.716,1.508,1.508,0,0,0,.471-.072L9.1,19.564a8.411,8.411,0,0,0,.964.537l.375,1.805a1.463,1.463,0,0,0,1.471,1.153h3.473a1.463,1.463,0,0,0,1.471-1.153l.375-1.805a8.51,8.51,0,0,0,.971-.537l1.78.587a1.508,1.508,0,0,0,.471.072,1.479,1.479,0,0,0,1.273-.716L23.4,16.641a1.406,1.406,0,0,0-.3-1.8ZM20.391,18.79l-2.523-.831a6.563,6.563,0,0,1-1.994,1.125l-.522,2.572H11.879l-.522-2.543A6.932,6.932,0,0,1,9.37,17.988l-2.531.8L5.1,15.925l2-1.719a6.21,6.21,0,0,1,0-2.242l-2-1.769L6.839,7.329l2.523.831a6.562,6.562,0,0,1,1.994-1.125l.522-2.572h3.473l.522,2.543A6.932,6.932,0,0,1,17.86,8.131l2.531-.8,1.736,2.865-2,1.719a6.21,6.21,0,0,1,0,2.242l2,1.769Z",
    transform: "translate(-3.619 -3.059)",
    fill: "#600097",
    stroke: "#600097",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12929",
    "data-name": "Path 12929",
    d: "M19.414,23.6a4.3,4.3,0,1,1,4.414-4.3,4.2,4.2,0,0,1-1.28,3.052A4.432,4.432,0,0,1,19.414,23.6Zm0-7.163a2.918,2.918,0,0,0-2.1.82,2.907,2.907,0,0,0,0,4.091,3.1,3.1,0,0,0,4.2,0,2.907,2.907,0,0,0,0-4.091A2.918,2.918,0,0,0,19.414,16.433Z",
    transform: "translate(-9.418 -9.298)",
    fill: "#600097"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashSettings);
export default __webpack_public_path__ + "static/media/dash-settings.b19f73558aa0de73ea38b75a8f3e3dec.svg";
export { ForwardRef as ReactComponent };